var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesMoreArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.75C1.30964 8.75 0.75 9.30964 0.75 10C0.75 10.6904 1.30964 11.25 2 11.25V8.75ZM23.8839 10.8839C24.372 10.3957 24.372 9.60427 23.8839 9.11612L15.9289 1.16117C15.4408 0.67301 14.6493 0.67301 14.1612 1.16117C13.673 1.64932 13.673 2.44078 14.1612 2.92893L21.2322 10L14.1612 17.0711C13.673 17.5592 13.673 18.3507 14.1612 18.8388C14.6493 19.327 15.4408 19.327 15.9289 18.8388L23.8839 10.8839ZM2 11.25H23V8.75H2V11.25Z",
    fill: "#2C00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesMoreArrow);
export default __webpack_public_path__ + "static/media/servicesMoreArrow.8c5fe40dd213398c60c606ead4d76194.svg";
export { ForwardRef as ReactComponent };